module.exports = __webpack_public_path__ + "static/media/60minutes.9aceea59.jpg";